module.exports = __webpack_public_path__ + "img/ba.18801f8.webp";